import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  const handleCTAClick = () => {
    const contactSection = document.querySelector('#contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero">
      <div className="hero-background">
        <img src="/images/background.png" alt="Mental wellness" className="hero-image" />
        <div className="hero-overlay"></div>
      </div>
      <div className="hero-content">
        <h1 className="hero-title animate-fade-in">
          艺术疗愈改变世界
        </h1>
        <p className="hero-subtitle animate-fade-in-delay">
          深圳市高帝思教育咨询有限公司致力于艺术心理教育在学校教育、家庭教育和专业人才培养领域的推广与应用，提升全民心灵幸福指数。
        </p>
        <div className="hero-cta animate-fade-in-delay-2">
          <button className="cta-button primary" onClick={handleCTAClick}>
            立即咨询
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
